import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from '../shared/services/shared.service';

export interface JobDefinition {
  key: string;
  name: string;
  route: string;
  description: string;
}

export interface JobLogLine {
  _id: string;
  run_id: string;
  ts: string;
  level: string;
  message: string;
  logger?: string;
  module?: string;
}

export interface JobTriggerResponse {
  success: boolean;
  job: string;
  run_id: string | null;
  triggeredAt: string;
  response: any;
}

export interface JobStatusResponse {
  finished: boolean;
  status?: string;
  summary?: any;
  source?: string;
}

@Injectable({ providedIn: 'root' })
export class JobsService {
  constructor(private http: HttpClient, private sharedService: SharedService) {}

  getDefinitions(): Observable<{ jobs: JobDefinition[] }> {
    return this.http.get<{ jobs: JobDefinition[] }>(`${this.sharedService.apiUrl}/jobs`);
  }

  trigger(jobKey: string): Observable<JobTriggerResponse> {
    return this.http.post<JobTriggerResponse>(`${this.sharedService.apiUrl}/jobs/trigger/${jobKey}`, {});
  }

  getLogs(runId: string, after?: string | null): Observable<{ lines: JobLogLine[]; count: number }> {
    const url = after
      ? `${this.sharedService.apiUrl}/jobs/logs/${runId}?after=${encodeURIComponent(after)}`
      : `${this.sharedService.apiUrl}/jobs/logs/${runId}`;
    return this.http.get<{ lines: JobLogLine[]; count: number }>(url);
  }

  getStatus(runId: string): Observable<JobStatusResponse> {
    return this.http.get<JobStatusResponse>(`${this.sharedService.apiUrl}/jobs/status/${runId}`);
  }
}
